function shopTheLook(){
    const dots = window.document.querySelectorAll('.js_look-dot-btn');
    const container = window.document.querySelector('.js_look-container');
    const placeholderContainer = window.document.querySelector('.js_look-slider-with-placeholder');
    const placeholder = window.document.querySelector('.js_look-placeholder-card');
    const cards = window.document.querySelectorAll('.js_look-card');
    const closeBtn = window.document.querySelector('.js_look-close-btn');
    const image = window.document.querySelector('.js_look-image img');

    if (dots.length < 1 || !container || !placeholderContainer || !placeholder || cards.length < 1 || !image || !closeBtn) return

    if(window.innerWidth > 1200)
        placeholderContainer.parentElement.style.maxHeight = image.height + 'px';
   
    window.addEventListener('resize',()=>{
        if(window.innerWidth > 1200)
            placeholderContainer.parentElement.style.maxHeight = image.height + 'px';
    })

    dots.forEach(dot => {
        dot.addEventListener('click',function(){
            if (container.classList.contains('active'))
                container.classList.remove('active');
            const cardIndex = dot.getAttribute('data-slider-thumb');
            const selectedCard = placeholderContainer.querySelector(`.look__slide[data-slide-index="${cardIndex}"]`); 
            cards.forEach(card => {
                if (card !== selectedCard) 
                    card.style.display='none';
                else{
                    card.scrollIntoView({
                        behavior:"smooth",
                        block:"center",
                        inline:"center",
                    });
                    card.style.display='flex';
                    placeholder.style.display='none';
                    closeBtn.style.display='block';
                }
            })

        })
    })

    closeBtn.addEventListener('click',function(){
        container.classList.add('active');
        cards.forEach(card => card.style.display='none')
        placeholder.style.display='block';
        this.style.display='none';
    })
}

window.addEventListener('load',shopTheLook)

// function shopTheLook(){
//     const dots = window.document.querySelectorAll('.js_dot-btn');
//     const slider = window.document.querySelector('.look__aside[data-popup-container]')
//     const placeholder = window.document.querySelector('.look__aside[data-popup-placeholder]')
//     const lookContainer = window.document.querySelector('.look[data-slider-placeholder]')

//     if (dots.length < 1 || !slider || !placeholder || !lookContainer) return;

//     const closeBtn = lookContainer.querySelector('.slide-close-btn-container');

//     if(!closeBtn) return;



//     // Hide placeholder and show product
//     dots.forEach(dot => {
//         dot.addEventListener('click',function(){
//             slider.focus();
//             if(!placeholder.classList.contains('active')) return;
//             closeBtn.style.display='block';
//             placeholder.classList.remove('active');
//             setTimeout(()=>{
//                 placeholder.style.display='none';
//             },150)
//         })
//     })
//     // Hide slider with products and show placeholder
//     closeBtn.addEventListener('click',function(){
//         placeholder.style.display='flex';
//         closeBtn.style.display='none';
//         setTimeout(()=>{
//             placeholder.classList.add('active');
//         },0)
//     })
// }
